import * as React from 'react'

export default () => (
  <svg width='384' height='267' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#a)'>
      <g clipPath='url(#b)'>
        <path
          d='M187.981 243.383c43.975-15.076 87.642-30.412 131.798-45.337 16.999-5.745 34.084-11.323 51.393-16.7 5.67-1.761-2.797 1.503-4.042 2.063-19.236 8.666-40.558 17.142-60.832 25.528-4.864 2.012-113.828 47.063-93.783 40.189 31.771-10.897 115.682-39.97 147.889-50.468 32.66-12.948-40.039 26.01-52.943 34.863'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
        />
      </g>
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='currentColor' d='M0 0h384v267H0z' />
      </clipPath>
      <clipPath id='b'>
        <path
          fill='currentColor'
          transform='rotate(-18.628 809.14 -440.22)'
          d='M0 0h198.461v41.418H0z'
        />
      </clipPath>
    </defs>
  </svg>
)
